module.exports = __webpack_public_path__ + "img/Slide_Principal_Escut_desk2.ec9cdf92.jpg";